"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CentralEventsService = void 0;
var detectors_1 = require("./detectors");
var enums = __importStar(require("./enums"));
var centralEventsClient_1 = __importDefault(require("./centralEventsClient"));
var CommonService_decorator_1 = require("../../decorators/CommonService.decorator");
var createContentViewEventData_1 = __importDefault(require("./createContentViewEventData"));
var User_service_1 = require("../User.service");
var CentralEventsService = /** @class */ (function () {
    function CentralEventsService(userService) {
        var _this = this;
        this.userService = userService;
        this.getGlobalCustomHeaders = function (profileVersionId) {
            var headers = {
                'accept': 'application/json, text/javascript, */*; q=0.01',
                'content-type': 'application/json',
            };
            var loginInfo = _this.userService.getLoginInfo();
            if (profileVersionId) {
                headers.SeismicClientName = (loginInfo === null || loginInfo === void 0 ? void 0 : loginInfo.clientType) || 'DocCenter';
                headers.ProfileVersionId = profileVersionId;
            }
            else {
                headers.SeismicClientName = (loginInfo === null || loginInfo === void 0 ? void 0 : loginInfo.clientType) || 'DocCenter';
                headers.ProfileVersionId = (loginInfo === null || loginInfo === void 0 ? void 0 : loginInfo.clientInfo.profileVersionIdNewsCenter) || (loginInfo === null || loginInfo === void 0 ? void 0 : loginInfo.clientInfo.profileVersionId) || '';
                headers.TeamSiteId = (loginInfo === null || loginInfo === void 0 ? void 0 : loginInfo.clientInfo.teamSiteId) || '';
            }
            if (window.EmbeddedPage && window.EmbeddedPage.seismicIntegratorContext) {
                headers.SeismicIntegratorContext = window.EmbeddedPage.seismicIntegratorContext;
            }
            else if (typeof window.SeismicSFDCClient != 'undefined') {
                headers.SeismicIntegratorContext = window.SeismicSFDCClient.Current.Salesforce.SeismicIntegratorContext;
            }
            return headers;
        };
        this.apiCallFunc = function (eventData) {
            // Need to get and set the headers for the embedded app to work
            var customHeaders = _this.getGlobalCustomHeaders();
            return new Promise(function (resolve, reject) {
                fetch('/JsonServiceApi/DataCollectionService.svc/SeismicEvent', {
                    method: 'POST',
                    headers: customHeaders,
                    body: JSON.stringify(eventData),
                })
                    .then(function (resp) { return resp.text(); })
                    .then(function (text) {
                    var data;
                    try {
                        data = JSON.parse(text);
                    }
                    catch (e) {
                        data = null;
                    }
                    if (data === null) {
                        console.log('Successfully called the Data Collection web service, but Event Data Collection is turned off.');
                        resolve('');
                    }
                    else if (data.Error) {
                        console.log('Error calling the Data Collection web service. Details: ', data.error);
                        reject(data.Error);
                    }
                    else {
                        console.log('Successfully called the Data Collection web service.');
                        resolve(data);
                    }
                })
                    .catch(function (error) {
                    console.log('Error calling the Data Collection web service. Details: ', error);
                    reject(error);
                });
            });
        };
        this.centralEventsClient = new centralEventsClient_1.default(this.apiCallFunc);
        this.CentralEventsClient = centralEventsClient_1.default;
        this.createContentViewEventData = createContentViewEventData_1.default;
        this.detectDevices = detectors_1.detectDevices;
        this.detectOS = detectors_1.detectOS;
        this.PRODUCTS = enums.PRODUCTS;
        this.APPLICATIONS = enums.APPLICATIONS;
        this.DEVICES = enums.DEVICES;
        this.OPERATING_SYSTEMS = enums.OPERATING_SYSTEMS;
    }
    CentralEventsService = __decorate([
        CommonService_decorator_1.CommonService('CentralEventsService'),
        __metadata("design:paramtypes", [User_service_1.UserService])
    ], CentralEventsService);
    return CentralEventsService;
}());
exports.CentralEventsService = CentralEventsService;
//# sourceMappingURL=CentralEvents.service.js.map